<script>
import NavBar from '@components/nav-bar'
import ErrorDisplay from '@components/error-display' /*  */
export default {
  components: { NavBar, ErrorDisplay },
}
</script>

<template>
  <div>
    <NavBar />
    <ErrorDisplay />
    <v-container fluid>
      <slot />
    </v-container>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.container {
  min-width: $size-content-width-min;
  max-width: $size-content-width-max;
  margin: 0 auto;
}
</style>
